import { render, staticRenderFns } from "./AccountFeatures.vue?vue&type=template&id=2c4dff1e&scoped=true"
import script from "./AccountFeatures.vue?vue&type=script&lang=js"
export * from "./AccountFeatures.vue?vue&type=script&lang=js"
import style0 from "./AccountFeatures.vue?vue&type=style&index=0&id=2c4dff1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4dff1e",
  null
  
)

export default component.exports